
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree192"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree192"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7we3r", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $jJbMR = parcelRequire("jJbMR");

var $ewFRw = parcelRequire("ewFRw");

var $lk5EI = parcelRequire("lk5EI");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    var context = new $ewFRw(defaultConfig);
    var instance = $jJbMR($ewFRw.prototype.request, context);
    // Copy axios.prototype to instance
    $gKvUL.extend(instance, $ewFRw.prototype, context);
    // Copy context to instance
    $gKvUL.extend(instance, context);
    return instance;
}
// Create the default instance to be exported
var $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance($lJY4v);
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = $ewFRw;
// Factory for creating new instances
$57966c7e0affc4cb$var$axios.create = function create(instanceConfig) {
    return $57966c7e0affc4cb$var$createInstance($lk5EI($57966c7e0affc4cb$var$axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.Cancel = (parcelRequire("4Tkeq"));

$57966c7e0affc4cb$var$axios.CancelToken = (parcelRequire("lAKPy"));

$57966c7e0affc4cb$var$axios.isCancel = (parcelRequire("7L4QX"));
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$57966c7e0affc4cb$var$axios.spread = (parcelRequire("JEeti"));

// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (parcelRequire("dxy9O"));
module.exports = $57966c7e0affc4cb$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $57966c7e0affc4cb$var$axios;

});
parcelRegister("gKvUL", function(module, exports) {
'use strict';

var $jJbMR = parcelRequire("jJbMR");
/*global toString:true*/ // utils is a library of generic helper functions non-specific to axios
var $c319b2c832c2914a$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $c319b2c832c2914a$var$isArray(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $c319b2c832c2914a$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBuffer(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $c319b2c832c2914a$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $c319b2c832c2914a$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $c319b2c832c2914a$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $c319b2c832c2914a$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $c319b2c832c2914a$var$isPlainObject(val) {
    if ($c319b2c832c2914a$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $c319b2c832c2914a$var$isDate(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $c319b2c832c2914a$var$isFile(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $c319b2c832c2914a$var$isBlob(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $c319b2c832c2914a$var$isFunction(val) {
    return $c319b2c832c2914a$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $c319b2c832c2914a$var$isStream(val) {
    return $c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $c319b2c832c2914a$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $c319b2c832c2914a$var$trim(str) {
    return str.replace(/^\s*/, '').replace(/\s*$/, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $c319b2c832c2914a$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $c319b2c832c2914a$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($c319b2c832c2914a$var$isPlainObject(result[key]) && $c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge(result[key], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[key] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $c319b2c832c2914a$var$extend(a, b, thisArg) {
    $c319b2c832c2914a$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $jJbMR(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $c319b2c832c2914a$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isStandardBrowserEnv: $c319b2c832c2914a$var$isStandardBrowserEnv,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM
};

});
parcelRegister("jJbMR", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("ewFRw", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $cbIsf = parcelRequire("cbIsf");

var $83RYu = parcelRequire("83RYu");

var $dlZEJ = parcelRequire("dlZEJ");

var $lk5EI = parcelRequire("lk5EI");
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a93486d2307f31c3$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $83RYu(),
        response: new $83RYu()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a93486d2307f31c3$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $lk5EI(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    // Hook up interceptors middleware
    var chain = [
        $dlZEJ,
        undefined
    ];
    var promise = Promise.resolve(config);
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    while(chain.length)promise = promise.then(chain.shift(), chain.shift());
    return promise;
};
$a93486d2307f31c3$var$Axios.prototype.getUri = function getUri(config) {
    config = $lk5EI(this.defaults, config);
    return $cbIsf(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$gKvUL.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$gKvUL.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($lk5EI(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $a93486d2307f31c3$var$Axios;

});
parcelRegister("cbIsf", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($gKvUL.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $gKvUL.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($gKvUL.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $gKvUL.forEach(val, function parseValue(v) {
                if ($gKvUL.isDate(v)) v = v.toISOString();
                else if ($gKvUL.isObject(v)) v = JSON.stringify(v);
                parts.push($8df8fedf1c1e4428$var$encode(key) + '=' + $8df8fedf1c1e4428$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("83RYu", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
function $5de878cd737ef277$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $5de878cd737ef277$var$InterceptorManager.prototype.use = function use(fulfilled, rejected) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $5de878cd737ef277$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $5de878cd737ef277$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $gKvUL.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $5de878cd737ef277$var$InterceptorManager;

});

parcelRegister("dlZEJ", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $7YJ0v = parcelRequire("7YJ0v");

var $7L4QX = parcelRequire("7L4QX");

var $lJY4v = parcelRequire("lJY4v");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7YJ0v(config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $gKvUL.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $gKvUL.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $lJY4v.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7YJ0v(response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$7L4QX(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7YJ0v(reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("7YJ0v", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    /*eslint no-param-reassign:0*/ $gKvUL.forEach(fns, function transform(fn) {
        data = fn(data, headers);
    });
    return data;
};

});

parcelRegister("7L4QX", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});

parcelRegister("lJY4v", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $kiL6T = parcelRequire("kiL6T");
var $fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, value) {
    if (!$gKvUL.isUndefined(headers) && $gKvUL.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $fd3c65eeb28abd71$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("at5cb"));
    return adapter;
}
var $fd3c65eeb28abd71$var$defaults = {
    adapter: $fd3c65eeb28abd71$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $kiL6T(headers, 'Accept');
            $kiL6T(headers, 'Content-Type');
            if ($gKvUL.isFormData(data) || $gKvUL.isArrayBuffer(data) || $gKvUL.isBuffer(data) || $gKvUL.isStream(data) || $gKvUL.isFile(data) || $gKvUL.isBlob(data)) return data;
            if ($gKvUL.isArrayBufferView(data)) return data.buffer;
            if ($gKvUL.isURLSearchParams(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($gKvUL.isObject(data)) {
                $fd3c65eeb28abd71$var$setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
                return JSON.stringify(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            /*eslint no-param-reassign:0*/ if (typeof data === 'string') try {
                data = JSON.parse(data);
            } catch (e) {}
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    }
};
$fd3c65eeb28abd71$var$defaults.headers = {
    common: {
        'Accept': 'application/json, text/plain, */*'
    }
};
$gKvUL.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = {};
});
$gKvUL.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $fd3c65eeb28abd71$var$defaults.headers[method] = $gKvUL.merge($fd3c65eeb28abd71$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $fd3c65eeb28abd71$var$defaults;

});
parcelRegister("kiL6T", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $gKvUL.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("at5cb", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");

var $kk0E9 = parcelRequire("kk0E9");

var $8JRzs = parcelRequire("8JRzs");

var $cbIsf = parcelRequire("cbIsf");

var $7GD7a = parcelRequire("7GD7a");

var $lDriZ = parcelRequire("lDriZ");

var $889er = parcelRequire("889er");

var $kjF3e = parcelRequire("kjF3e");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if ($gKvUL.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $7GD7a(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $cbIsf(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        // Listen for ready state
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $lDriZ(request.getAllResponseHeaders()) : null;
            var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $kk0E9(resolve, reject, response);
            // Clean up request
            request = null;
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($kjF3e('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($kjF3e('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($kjF3e(timeoutErrorMessage, config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($gKvUL.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $889er(fullPath)) && config.xsrfCookieName ? $8JRzs.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $gKvUL.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$gKvUL.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (config.responseType) try {
            request.responseType = config.responseType;
        } catch (e) {
            // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
            // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
            if (config.responseType !== 'json') throw e;
        }
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken) // Handle cancellation
        config.cancelToken.promise.then(function onCanceled(cancel) {
            if (!request) return;
            request.abort();
            reject(cancel);
            // Clean up request
            request = null;
        });
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("kk0E9", function(module, exports) {
'use strict';

var $kjF3e = parcelRequire("kjF3e");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($kjF3e('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("kjF3e", function(module, exports) {
'use strict';

var $8v8A7 = parcelRequire("8v8A7");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $8v8A7(error, config, code, request, response);
};

});
parcelRegister("8v8A7", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code
        };
    };
    return error;
};

});



parcelRegister("8JRzs", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($gKvUL.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($gKvUL.isString(path)) cookie.push('path=' + path);
            if ($gKvUL.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("7GD7a", function(module, exports) {
'use strict';

var $ckHwb = parcelRequire("ckHwb");

var $fE4ul = parcelRequire("fE4ul");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$ckHwb(requestedURL)) return $fE4ul(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("ckHwb", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("fE4ul", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("lDriZ", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $fc026bbf9ee156f1$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $gKvUL.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $gKvUL.trim(line.substr(0, i)).toLowerCase();
        val = $gKvUL.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("889er", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
module.exports = $gKvUL.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $gKvUL.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});




parcelRegister("lk5EI", function(module, exports) {
'use strict';

var $gKvUL = parcelRequire("gKvUL");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    var valueFromConfig2Keys = [
        'url',
        'method',
        'data'
    ];
    var mergeDeepPropertiesKeys = [
        'headers',
        'auth',
        'proxy',
        'params'
    ];
    var defaultToConfig2Keys = [
        'baseURL',
        'transformRequest',
        'transformResponse',
        'paramsSerializer',
        'timeout',
        'timeoutMessage',
        'withCredentials',
        'adapter',
        'responseType',
        'xsrfCookieName',
        'xsrfHeaderName',
        'onUploadProgress',
        'onDownloadProgress',
        'decompress',
        'maxContentLength',
        'maxBodyLength',
        'maxRedirects',
        'transport',
        'httpAgent',
        'httpsAgent',
        'cancelToken',
        'socketPath',
        'responseEncoding'
    ];
    var directMergeKeys = [
        'validateStatus'
    ];
    function getMergedValue(target, source) {
        if ($gKvUL.isPlainObject(target) && $gKvUL.isPlainObject(source)) return $gKvUL.merge(target, source);
        else if ($gKvUL.isPlainObject(source)) return $gKvUL.merge({}, source);
        else if ($gKvUL.isArray(source)) return source.slice();
        return source;
    }
    function mergeDeepProperties(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    }
    $gKvUL.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
    });
    $gKvUL.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);
    $gKvUL.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
        if (!$gKvUL.isUndefined(config2[prop])) config[prop] = getMergedValue(undefined, config2[prop]);
        else if (!$gKvUL.isUndefined(config1[prop])) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    $gKvUL.forEach(directMergeKeys, function merge(prop) {
        if (prop in config2) config[prop] = getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) config[prop] = getMergedValue(undefined, config1[prop]);
    });
    var axiosKeys = valueFromConfig2Keys.concat(mergeDeepPropertiesKeys).concat(defaultToConfig2Keys).concat(directMergeKeys);
    var otherKeys = Object.keys(config1).concat(Object.keys(config2)).filter(function filterAxiosKeys(key) {
        return axiosKeys.indexOf(key) === -1;
    });
    $gKvUL.forEach(otherKeys, mergeDeepProperties);
    return config;
};

});


parcelRegister("4Tkeq", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $38fbfe0afbd5bf1e$var$Cancel(message) {
    this.message = message;
}
$38fbfe0afbd5bf1e$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$38fbfe0afbd5bf1e$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $38fbfe0afbd5bf1e$var$Cancel;

});

parcelRegister("lAKPy", function(module, exports) {
'use strict';

var $4Tkeq = parcelRequire("4Tkeq");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $fb81495929d8a282$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $4Tkeq(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $fb81495929d8a282$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $fb81495929d8a282$var$CancelToken.source = function source() {
    var cancel;
    var token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $fb81495929d8a282$var$CancelToken;

});

parcelRegister("JEeti", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("dxy9O", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});


var $b302555736d21bd7$exports = {};

$b302555736d21bd7$exports = (parcelRequire("7we3r"));


//Function that calls the geoserver table councillor in order to get the information for the councillors of the selected ward. The ward has been selected from the list of addresses given by the postcode API call. 
const $35da740d59af89ba$var$GetCouncillor = ()=>{
    //TODO: remove the hard-coded version!!! It is only here because we are using the test proxy
    let selectedWard = document.querySelector('#selectedAddress').value;
    // console.log('Selected Ward',selectedWard)
    //let selectedWard = 'Hackney Central';
    (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get(`${"https://map2.hackney.gov.uk/geoserver/government/ows/"}?service=WFS&version=1.0.0&request=GetFeature&outputFormat=json&typeName=government:councillor&propertyName=councillor1_name,councillor1_party,councillor1_contact,councillor2_name,councillor2_party,councillor2_contact,councillor3_name,councillor3_party,councillor3_contact&cql_filter=ward_name='${selectedWard}'`, {}).then((res)=>{
        // console.log(res.data)
        let councillor1_name = res.data.features[0].properties.councillor1_name;
        let councillor2_name = res.data.features[0].properties.councillor2_name;
        let councillor3_name = res.data.features[0].properties.councillor3_name;
        let councillor1_contact = res.data.features[0].properties.councillor1_contact;
        let councillor2_contact = res.data.features[0].properties.councillor2_contact;
        let councillor3_contact = res.data.features[0].properties.councillor3_contact;
        let councillor1_party = res.data.features[0].properties.councillor1_party;
        let councillor2_party = res.data.features[0].properties.councillor2_party;
        let councillor3_party = res.data.features[0].properties.councillor3_party;
        document.querySelector('code').innerHTML = "<label class='govuk-label  lbh-label' for='councillor_table'>Councillors for the ward of <em>" + selectedWard + "</em>: </label>";
        if (councillor3_name) {
            if (councillor3_name == "Vacant seat") document.querySelector('code').innerHTML += "<table class='govuk-table  lbh-table' id='councillor_table'> <tbody class='govuk-table__body'><tr class='govuk-table__row'><td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor1_name + "</a></td>" + "<td class='govuk-table__cell'>" + (councillor1_party || "&nbsp &nbsp") + "</td>" + "<td class='govuk-table__cell'><a href='mailto:" + councillor1_contact + "'>" + (councillor1_contact || "&nbsp &nbsp") + "</td>" + "</tr>" + "<tr class='govuk-table__row'>" + "<td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor2_name + "</td>" + "<td class='govuk-table__cell'>" + (councillor2_party || "&nbsp &nbsp") + "</td>" + "<td class='govuk-table__cell'><a href='mailto:" + councillor2_contact + "'>" + (councillor2_contact || "&nbsp &nbsp") + "</td>" + "</tr>" + "<tr class='govuk-table__row'>" + "<td class='govuk-table__cell'>" + councillor3_name + "</td>" + "<td class='govuk-table__cell'>" + (councillor3_party || "&nbsp &nbsp") + "</td>" + "<td class='govuk-table__cell'></td>" + "</tr></tbody></table>";
            else document.querySelector('code').innerHTML += "<table class='govuk-table  lbh-table' id='councillor_table'> <tbody class='govuk-table__body'><tr class='govuk-table__row'><td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor1_name + "</a></td>" + "<td class='govuk-table__cell'>" + (councillor1_party || "&nbsp &nbsp") + "</td>" + "<td class='govuk-table__cell'><a href='mailto:" + councillor1_contact + "'>" + (councillor1_contact || "&nbsp &nbsp") + "</td>" + "</tr>" + "<tr class='govuk-table__row'>" + "<td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor2_name + "</td>" + "<td class='govuk-table__cell'>" + (councillor2_party || "&nbsp &nbsp") + "</td>" + "<td class='govuk-table__cell'><a href='mailto:" + councillor2_contact + "'>" + (councillor2_contact || "&nbsp &nbsp") + "</td>" + "</tr>" + "<tr class='govuk-table__row'>" + "<td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor3_name + "</td>" + "<td class='govuk-table__cell'>" + (councillor3_party || "&nbsp &nbsp") + "</td>" + "<td class='govuk-table__cell'><a href='mailto:" + councillor3_contact + "'>" + (councillor3_contact || "&nbsp &nbsp") + "</td>" + "</tr></tbody></table>";
        } else {
            if (councillor1_name == "Vacant seat") document.querySelector('code').innerHTML += "<table class='govuk-table  lbh-table'> <tbody class='govuk-table__body'><tr class='govuk-table__row'><td class='govuk-table__cell'>" + councillor1_name + "</td>" + "<td class='govuk-table__cell'>" + (councillor1_party || "&nbsp &nbsp") + "</td>" + "<td class='govuk-table__cell'></td>" + "</tr>" + "<tr class='govuk-table__row'>" + "<td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor2_name + "</td>" + "<td class='govuk-table__cell'>" + (councillor2_party || "&nbsp &nbsp") + "</td>" + "<td class='govuk-table__cell'><a href='mailto:" + councillor2_contact + "'>" + (councillor2_contact || "&nbsp &nbsp") + "</td>" + "</tr></tbody></table>";
            else if (councillor2_name == "Vacant seat") {
                console.log(councillor2_name);
                document.querySelector('code').innerHTML += "<table class='govuk-table  lbh-table'> <tbody class='govuk-table__body'><tr class='govuk-table__row'><td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor1_name + "</td>" + "<td class='govuk-table__cell'>" + (councillor1_party || "&nbsp &nbsp") + "</td>" + "<td class='govuk-table__cell'><a href='mailto:" + councillor1_contact + "'>" + (councillor1_contact || "&nbsp &nbsp") + "</td>" + "</tr>" + "<tr class='govuk-table__row'>" + "<td class='govuk-table__cell'>" + councillor2_name + "</td>" + "<td class='govuk-table__cell'>" + (councillor2_party || "&nbsp &nbsp") + "</td>" + "<td class='govuk-table__cell'></td>" + "</tr></tbody></table>";
            } else document.querySelector('code').innerHTML += "<table class='govuk-table  lbh-table'> <tbody class='govuk-table__body'><tr class='govuk-table__row'><td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor1_name + "</td>" + "<td class='govuk-table__cell'>" + (councillor1_party || "&nbsp &nbsp") + "</td>" + "<td class='govuk-table__cell'><a href='mailto:" + councillor1_contact + "'>" + (councillor1_contact || "&nbsp &nbsp") + "</td>" + "</tr>" + "<tr class='govuk-table__row'>" + "<td class='govuk-table__cell'><a href='https://www.hackney.gov.uk/council-and-elections/mayor-cabinet-and-councillors/councillors/your-councillors' target='_blank'>" + councillor2_name + "</td>" + "<td class='govuk-table__cell'>" + (councillor2_party || "&nbsp &nbsp") + "</td>" + "<td class='govuk-table__cell'><a href='mailto:" + councillor2_contact + "'>" + (councillor2_contact || "&nbsp &nbsp") + "</td>" + "</tr></tbody></table>";
        }
    //Catch error of the second axios call - councillor table (Geoserver)
    }).catch((error)=>{
        console.log('error geoserver!!!');
        document.getElementById("error_message").innerHTML = 'Sorry, there was a problem retrieving councillors for this address. <br>Please note that this service is only available for Hackney addresses.';
        console.error(error);
    });
};
const $35da740d59af89ba$var$GetAddressesViaProxy = async ()=>{
    //type="search"  
    //empty error message and previous lists
    document.getElementById("error_message").innerHTML = "";
    document.getElementById("addresses").innerHTML = 'Loading addresses...';
    document.querySelector('code').innerHTML = '';
    let postcode = document.getElementById("postcode").value;
    let ward1 = null;
    let results1 = null;
    let full_address1 = null;
    //empty former councillors list
    document.querySelector('code').innerHTML = '';
    //First call to get the list of addresses from a postcode
    const res = await fetch(`${"https://zwb5f0hl7b.execute-api.us-east-1.amazonaws.com/production/address-v2-proxy"}?format=detailed&postcode=${postcode}`);
    //  const res = await fetch(`${process.env.ADDRESSES_API_PROXY_STAGING}?format=detailed&postcode=${postcode}`);
    const response = await res.json();
    //console.log(response.data.data);
    //document.querySelector("code").innerHTML = JSON.stringify(response);
    // Add error message is the postcode is not correct
    if (response.error) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        // console.log(error.response.data);
        // console.log(error.response.status);
        // console.log(error.response.headers);
        // if (!error.isValid) {
        //   console.log(error.response.data.error.validationErrors[0].message);
        //   document.getElementById("error_message").innerHTML = error.response.data.error.validationErrors[0].message;
        // }
        document.getElementById("error_message").innerHTML = "Sorry, an error occured while retrieving addresses";
        document.getElementById("addresses").innerHTML = '';
    } else if (response.data.statusCode != 200) {
        if (!response.data.error.isValid) {
            document.getElementById("error_message").innerHTML = "Please enter a valid postcode";
            document.getElementById("addresses").innerHTML = '';
        } else {
            document.getElementById("error_message").innerHTML = response.data.error;
            document.getElementById("addresses").innerHTML = '';
        }
    } else {
        results1 = response.data.data.address;
        let pageCount = response.data.data.page_count;
        // console.log(results)
        if (results1.length === 0) document.getElementById("error_message").innerHTML = "No address found at this postcode";
        else {
            document.getElementById("addresses").innerHTML = "<div class='govuk-form-group lbh-form-group'><select class='govuk-select govuk-!-width-full lbh-select' id='selectedAddress' name='selectedAddress' >";
            document.getElementById("selectedAddress").innerHTML += "<option disabled selected value> Select your address from the list </option>";
            results1.forEach((element)=>{
                //full_address = results[index].line1 + ", " + results[index].line2 + ", " + results[index].line3 + ", " + results[index].postcode;
                full_address1 = [
                    element.line1,
                    element.line2,
                    element.line3,
                    element.line4
                ].filter(Boolean).join(", ");
                ward1 = element.ward;
                //remove simple quotes and special characters
                ward1 = ward1.replace("'", "");
                ward1 = ward1.replace('&', 'and');
                document.getElementById("selectedAddress").innerHTML += "<option value='" + ward1 + "'>" + full_address1 + "</option>";
            // console.log(document.getElementById("selectedAddress"))
            });
            //load more pages of resukts if needed -
            if (pageCount > 1) for(pgindex = 2; pgindex <= pageCount; ++pgindex)$35da740d59af89ba$var$loadAddressAPIPageViaProxy(postcode, pgindex);
            //close list
            document.getElementById("addresses").innerHTML += "</select></div>";
            document.getElementById("selectedAddress").addEventListener('change', $35da740d59af89ba$var$GetCouncillor);
        }
    }
};
//List the addresses from the postcode calling the Addresses API. The addresses are printed as a drop down list where you can select. The ward of the selected one is used to called the function GetCouncillor()
const $35da740d59af89ba$var$GetAddressesWithoutProxy = ()=>{
    //empty error message and previous lists
    document.getElementById("error_message").innerHTML = "";
    document.getElementById("addresses").innerHTML = '';
    document.querySelector('code').innerHTML = '';
    let postcode = document.getElementById("postcode").value;
    let ward1 = null;
    let results1 = null;
    let full_address1 = null;
    //empty former councillors list
    document.querySelector('code').innerHTML = '';
    //First call to get the list of addresses from a postcode
    (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get(`${undefined}?format=detailed&postcode=${postcode}`, {
        headers: {
            Authorization: undefined
        }
    }).then((res)=>{
        results1 = res.data.data.address;
        let pageCount = res.data.data.page_count;
        //console.log(results)
        if (results1.length === 0) document.getElementById("error_message").innerHTML = "No address found at this postcode";
        else {
            // document.getElementById("addresses").innerHTML +="<div class='govuk-form-group lbh-form-group'> <label class='govuk-label  lbh-label' for='sselectedAddress'>  Select your address from the list </label>";
            // document.getElementById("addresses").innerHTML +="<select class='govuk-select  lbh-select' id='selectedAddress' name='selectedAddress' onchange='GetCouncillor()'>";
            document.getElementById("addresses").innerHTML = "<div class='govuk-form-group lbh-form-group'><select class='govuk-select govuk-!-width-full lbh-select' id='selectedAddress' name='selectedAddress'>";
            document.getElementById("selectedAddress").innerHTML += "<option disabled selected value> Select your address from the list </option>";
            results1.forEach((addressLine)=>{
                //full_address = results[index].line1 + ", " + results[index].line2 + ", " + results[index].line3 + ", " + results[index].postcode;
                full_address1 = [
                    addressLine.line1,
                    addressLine.line2,
                    addressLine.line3,
                    addressLine.line4
                ].filter(Boolean).join(", ");
                ward1 = addressLine.ward;
                //remove simple quotes and special characters
                ward1 = ward1.replace("'", "");
                ward1 = ward1.replace('&', 'and');
                document.getElementById("selectedAddress").innerHTML += "<option value='" + ward1 + "'>" + full_address1 + "</option>";
            });
            //load more pages of resukts if needed
            if (pageCount > 1) for(pgindex = 2; pgindex <= pageCount; ++pgindex)$35da740d59af89ba$var$loadAddressAPIPage(postcode, pgindex);
            //close list
            document.getElementById("addresses").innerHTML += "</select></div>";
            document.getElementById("selectedAddress").addEventListener('change', $35da740d59af89ba$var$GetCouncillor);
        }
    })//Catch error of the fist axios call - addresses API
    .catch((error)=>{
        if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            if (!error.isValid) {
                console.log(error.response.data.error.validationErrors[0].message);
                document.getElementById("error_message").innerHTML = error.response.data.error.validationErrors[0].message;
            }
        } else if (error.request) // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
        else // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message);
        console.log(error.config);
    });
};
let $35da740d59af89ba$var$postcode = document.getElementById('postcode');
let $35da740d59af89ba$var$searchBtn = document.getElementById('search');
$35da740d59af89ba$var$postcode.addEventListener('keyup', (e)=>{
    if (e.key == 'Enter') $35da740d59af89ba$var$GetAddressesViaProxy();
});
$35da740d59af89ba$var$searchBtn.addEventListener('click', (e)=>{
    $35da740d59af89ba$var$GetAddressesViaProxy();
//GetAddressesWithoutProxy();
});
//listener for the clear x in the input
$35da740d59af89ba$var$postcode.addEventListener("search", (e)=>{
    document.getElementById("error_message").innerHTML = "";
    document.getElementById("addresses").innerHTML = '';
    document.querySelector('code').innerHTML = '';
});
//function to add one page of results to the options list
const $35da740d59af89ba$var$loadAddressAPIPage = (postcode, pg)=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($b302555736d21bd7$exports))).get(`${undefined}?format=detailed&postcode=${postcode}'&page=${pg}`, {
        headers: {
            Authorization: undefined
        }
    }).then((res)=>{
        //console.log('page ' + pg + ' = ' + res);
        results = res.data.data.address;
        for(index = 0; index < addresses.length; ++index){
            //full_address = results[index].line1 + ", " + results[index].line2 + ", " + results[index].line3 + ", " + results[index].postcode;
            full_address = [
                results[index].line1,
                results[index].line2,
                results[index].line3,
                results[index].line4
            ].filter(Boolean).join(", ");
            ward = results[index].ward;
            //remove simple quotes and special characters
            ward = ward.replace("'", "");
            ward = ward.replace('&', 'and');
            document.getElementById("selectedAddress").innerHTML += "<option value='" + ward + "'>" + full_address + "</option>";
        }
    }).catch((error)=>{
        //there shouldn't be anything as the request already returned sth correct for the first page of results
        console.log(error.config);
    });
};
const $35da740d59af89ba$var$loadAddressAPIPageViaProxy = async (postcode, pg)=>{
    const res = await fetch(`${"https://zwb5f0hl7b.execute-api.us-east-1.amazonaws.com/production/address-v2-proxy"}?format=detailed&postcode=${postcode}&page=${pg}`);
    // const res = await fetch(`${process.env.ADDRESSES_API_PROXY_STAGING}?format=detailed&postcode=${postcode}&page=${pg}`);
    const response = await res.json();
    results = response.data.data.address;
    //console.log(results);
    for(index = 0; index < results.length; ++index){
        //full_address = results[index].line1 + ", " + results[index].line2 + ", " + results[index].line3 + ", " + results[index].postcode;
        full_address = [
            results[index].line1,
            results[index].line2,
            results[index].line3,
            results[index].line4
        ].filter(Boolean).join(", ");
        ward = results[index].ward;
        //remove simple quotes and special characters
        ward = ward.replace("'", "");
        ward = ward.replace('&', 'and');
        document.getElementById("selectedAddress").innerHTML += "<option value='" + ward + "'>" + full_address + "</option>";
    }
};


//# sourceMappingURL=lbh-find-my-councillor.1155fce7.js.map
